import { render, staticRenderFns } from "./Woundcare.vue?vue&type=template&id=6401ef78&"
import script from "./Woundcare.vue?vue&type=script&lang=js&"
export * from "./Woundcare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports